@import "../../packages/shared/scss";

@mixin shopSection() {
  .wishlist-container {
    padding-block: p-px-to-rem(16px);
    padding-inline: p-px-to-rem(16px);
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: p-px-to-rem(12px);
    margin-block-start: p-px-to-rem(48px);

    @include pds-media-query-max("s") {
      background-color: #eeeff2;
    }

    .no-icon {
      padding-inline-start: p-px-to-rem(28px);
    }
  }
}

:host {
  display: block;
  box-sizing: border-box;

  @include shopSection();
}
